// src/components/web/cupones.js
import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function Cupones() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        // Endpoint correcto según las rutas que definimos: GET /api/web/cupones
        const r = await fetch(`${API_BASE}/web/cupones`, {
          credentials: 'include',
        });
        const j = await r.json();

        // Acepta ambas formas por si cambiaste el backend
        const list = Array.isArray(j?.cupones)
          ? j.cupones
          : Array.isArray(j?.data)
          ? j.data
          : [];

        setData(list);
      } catch {
        setData([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="text-3xl font-extrabold">Cupones</h1>
      <p className="mt-2 text-slate-600">
        Aprovecha nuestras promociones activas para productos específicos.
      </p>

      {loading ? (
        <p className="mt-6">Cargando...</p>
      ) : data.length === 0 ? (
        <p className="mt-6 text-slate-500">Por ahora no hay cupones activos.</p>
      ) : (
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.map((c) => (
            <div key={c.id} className="rounded-2xl border shadow-sm overflow-hidden">
              <div
                className="h-2"
                style={{ backgroundColor: c.color_hex || "#0ea5e9" }}
              />
              <div className="p-4">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-lg font-bold">{c.nombre}</h3>
                  {/* si existe "codigo", lo mostramos */}
                  {!!c.codigo && (
                    <span className="text-xs font-semibold px-2 py-1 rounded-lg border border-slate-200">
                      {c.codigo}
                    </span>
                  )}
                </div>

                {c.producto_nombre_snapshot && (
                  <p className="text-sm text-slate-600 mt-1">
                    Producto:{" "}
                    <span className="font-medium">
                      {c.producto_nombre_snapshot}
                    </span>
                  </p>
                )}

                <p className="mt-2 text-sm">
                  {c.descripcion || "Cupón promocional"}
                </p>

                <div className="mt-3 text-sm flex items-center justify-between">
                  <span className="font-semibold">
                    -{Number(c.porcentaje_descuento || 0)}%
                  </span>
                  <span className="text-slate-500">
                    Vence:{" "}
                    {c.fecha_fin
                      ? new Date(c.fecha_fin).toLocaleDateString()
                      : "—"}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
